import { render, staticRenderFns } from "./SimeparTablet.vue?vue&type=template&id=23cb04d6&scoped=true"
import script from "./SimeparTablet.vue?vue&type=script&lang=js"
export * from "./SimeparTablet.vue?vue&type=script&lang=js"
import style0 from "./SimeparTablet.vue?vue&type=style&index=0&id=23cb04d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb04d6",
  null
  
)

export default component.exports